export const themes = {
  pinkBlue: {
    name: 'Pink to Blue',
    background: 'linear-gradient(145deg, hsla(339, 100%, 55%, 1) 0%, hsla(197, 100%, 64%, 1) 100%)',
    textColor: 'rgba(255, 255, 255, 0.95)',
    streetBgColor: 'rgba(0, 0, 0, 0.15)',
    actionBgColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: 20,
    fontFamily: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    titleFontWeight: 600,
    textFontWeight: 400,
    streetTextColor: 'rgba(255, 255, 255, 0.95)',
    actionTextColor: 'rgba(255, 255, 255, 0.9)',
  },
  bluePurple: {
    name: 'Blue to Purple',
    background: 'linear-gradient(145deg, hsla(197, 100%, 63%, 1) 0%, hsla(294, 100%, 55%, 1) 100%)',
    textColor: 'rgba(255, 255, 255, 0.95)',
    streetBgColor: 'rgba(0, 0, 0, 0.15)',
    actionBgColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: 20,
    fontFamily: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    titleFontWeight: 600,
    textFontWeight: 400,
    streetTextColor: 'rgba(255, 255, 255, 0.95)',
    actionTextColor: 'rgba(255, 255, 255, 0.9)',
  },
  bluePink: {
    name: 'Blue to Pink',
    background: 'linear-gradient(145deg, hsla(211, 96%, 62%, 1) 0%, hsla(295, 94%, 76%, 1) 100%)',
    textColor: 'rgba(255, 255, 255, 0.95)',
    streetBgColor: 'rgba(0, 0, 0, 0.15)',
    actionBgColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: 20,
    fontFamily: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    titleFontWeight: 600,
    textFontWeight: 400,
    streetTextColor: 'rgba(255, 255, 255, 0.95)',
    actionTextColor: 'rgba(255, 255, 255, 0.9)',
  },
  purpleBlue: {
    name: 'Purple to Blue',
    background: 'linear-gradient(145deg, hsla(259, 84%, 78%, 1) 0%, hsla(206, 67%, 75%, 1) 100%)',
    textColor: 'rgba(255, 255, 255, 0.95)',
    streetBgColor: 'rgba(0, 0, 0, 0.15)',
    actionBgColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: 20,
    fontFamily: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    titleFontWeight: 600,
    textFontWeight: 400,
    streetTextColor: 'rgba(255, 255, 255, 0.95)',
    actionTextColor: 'rgba(255, 255, 255, 0.9)',
  },
  tealPurple: {
    name: 'Teal to Purple',
    background: 'linear-gradient(145deg, hsla(185, 64%, 51%, 1) 0%, hsla(277, 74%, 24%, 1) 100%)',
    textColor: 'rgba(255, 255, 255, 0.95)',
    streetBgColor: 'rgba(0, 0, 0, 0.15)',
    actionBgColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: 20,
    fontFamily: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    titleFontWeight: 600,
    textFontWeight: 400,
    streetTextColor: 'rgba(255, 255, 255, 0.95)',
    actionTextColor: 'rgba(255, 255, 255, 0.9)',
  },
  darkBlue: {
    name: 'Dark Blue',
    background: 'linear-gradient(145deg, hsla(213, 77%, 14%, 1) 0%, hsla(202, 27%, 45%, 1) 100%)',
    textColor: 'rgba(255, 255, 255, 0.95)',
    streetBgColor: 'rgba(255, 255, 255, 0.15)',
    actionBgColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: 20,
    fontFamily: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    titleFontWeight: 600,
    textFontWeight: 400,
    streetTextColor: 'rgba(255, 255, 255, 0.95)',
    actionTextColor: 'rgba(255, 255, 255, 0.9)',
  }
}; 